import React from 'react';
import PropTypes from 'prop-types';

const Towels = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.63 12.435h3.478c3.457 0-4.428-6.521-9.094-6.521-5.025 0-12.555 6.521-9.166 6.521h3.478"
    />
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.282 3.305a1.305 1.305 0 1 0-1.304 1.305l.037 1.304M6.325 19.392H17.63m0-9.565H6.326V22H17.63V9.827Z"
    />
  </svg>
);

Towels.propTypes = {
  color: PropTypes.string
};

export default Towels;
